export const technicians = (state) => state.technicians //eslint-disable-line
